import React, {Component}  from 'react';
import {connect} from 'react-redux';
import {Row,Col,Checkbox,message,Input,Radio,Select,Button,Icon,Modal} from 'antd';

import axios from 'axios'
import API from '../../../../API/api'

class batchPushImage extends Component {
    state = {
        inited:false,

    }
    componentWillMount() {
        axios.post(API.UPLOAD_TOKEN).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.uptoken = res.data.uptoken
                this.upload();
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }

    uptoken = ""

    /*
    *
    * 上传图片
    * */
    upload = () => {
        const __this = this;
        let option = {
            runtimes: 'html5,html4',
            browse_button: `batchPushImage_upload`,
            max_file_size: '100mb',
            dragdrop: true,
            chunk_size: '4mb',
            uptoken: this.uptoken,
            // uptoken_url: me.options.uploadTokenUrl + "?token=" + ReadCookie(COOKIE_NAME),
            domain: 'https://tikuqiniu.knowbox.cn/',
            drop_element: `batchPushImage_preview`,
            get_new_uptoken: false,
            // unique_names: false,
            save_key: false,
            // save_key: true,
            auto_start: true,
            disable_statistics_report: true,
            log_level: 0,
            filters: {
                max_file_size: '100mb',
                prevent_duplicates: true,
                //Specify what files to browse for
                mime_types: [
                    {title: "image files", extensions: "jpeg,png,jpg"},
                ]
            },
            init: {
                'FilesAdded': function (up, files) {
                    __this.filesNum = files.length
                    __this.setState({loadding:true,upfileNum:0})
                },
                'BeforeUpload': function (up, file) {
                },
                'UploadProgress': function (up, file) {
                },
                'UploadComplete': function () {
                },
                'FileUploaded': function (up, file, info) {
                    let res = JSON.parse(info);
                    let domain = up.getOption('domain');
                    // __this.data.videoStem.batchPushImage = `${domain}${res.key}`

                    let upfileNum = __this.state.upfileNum+1
                    if(upfileNum === __this.filesNum){
                        __this.setState({loadding:false})
                        message.success(`上传成功${upfileNum}张图片`)
                    }
                    __this.setState({upfileNum})
                },
                'Key': function (up, file) {
                    var key = "qmis/entryreplace/"+file.name.replace(/.png$|.jpg$/,'');
                    // var key = "qmis/entryreplace/bbbbb.png";

                    // do something with key
                    return key
                },
                'Error': function (up, err, errTip) {
                    console.log(err.message);
                },
            },



        }
            let QbatchPushImage = new window.QiniuJsSDK()
            QbatchPushImage.uploader(option)


    }

    render(){


        return(
            <div style={{display:'inline-block',marginLeft:10}}>

                    <Button style={{verticalAlign:'middle'}}  id={`batchPushImage_upload`} type="primary">
                        批量导入图片
                    </Button>

                <Modal
                    visible={this.state.loadding}
                    footer={''}
                    width={300}
                    onCancel={() => {this.setState({loadding:false})}}>
                    <div style={{position:'relative'}}>
                        <div style={{fontSize:19,color:'#108ee9',textAlign:'center'}}>
                            图片正在导入中。。。
                            {
                                this.state.upfileNum>0&&
                                <div>已上传{this.state.upfileNum}张</div>
                            }

                        </div>
                    </div>

                </Modal>
            </div>
        );
    }
}
const mapStateTopProps = (state) => {
    return {

    };
}

const mapDispatchToProps = dispatch => {
    return {

    }
};


export default connect (mapStateTopProps,mapDispatchToProps)(batchPushImage)


// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_list/batchPushImage/batchPushImage.js